import { gql } from '@apollo/client';
import {
  ListChapterByClientQueryVariables,
  useListChapterByClientQuery as useQuery,
} from '@/operations/queries/novelChapter/__generated__/useWebNovelChapterList.generated';

import { useRouter } from 'next/router';

export const WEB_NOVEL_CHAPTER_ITEM = gql`
  fragment WebNovelChapterDto on Chapter {
    storyId
    chapterId
    chapterIndex
    name
    adsOn
    freedAt
    price
    currentPlayingStatus
    isAdult
    userPurchasedChapter {
      usedAmount
    }
  }
`;

export const WEB_NOVEL_CHAPTER_LIST = gql`
  query ListChapterByClient($storyId: Int!, $page: Int, $pageSize: Int) {
    listChapterByClient(
      data: { storyId: $storyId, page: $page, pageSize: $pageSize }
    ) {
      list {
        ...WebNovelChapterDto
      }
      totalCount
      page
      pageSize
    }
  }
  ${WEB_NOVEL_CHAPTER_ITEM}
`;

export const useWebNovelChapterList = (
  variables: ListChapterByClientQueryVariables,
) => {
  const router = useRouter();
  const { data, fetchMore, networkStatus } = useQuery({
    variables,
    onError: () => {
      router.push('/404');
    },
  });

  const hasNext =
    data &&
    data?.listChapterByClient.totalCount >
      data?.listChapterByClient.list.length;

  return { data, fetchMore, networkStatus, hasNext };
};
